import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { BaseParams } from 'types/utils'

export function useDeleteImage() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function deleteImage({
    id,
    params
  }: BaseParams<{ image_pk: string }, 'DELETE'>) {
    const res = await apiClient.delete(
      SNA_PREFIX + `flats/${id}/images/${params?.image_pk}`
    )

    return res.data
  }

  return useMutation({
    mutationFn: deleteImage,
    onSuccess: (_, variables) => {
      variables.params?.onSuccess?.()
      toast.success({ message: t('imageDeleted') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
    },
    onError // Updated to use useOnError
  })
}
